import { cloneDeep, isNil } from 'lodash';
import priceTagTransforms from '@enums/price-tag-transforms';
import { getUnitsPerTrigger } from './mechanic-reader';

const identity = {
    toMechanic: value => value,
    fromMechanic: value => value,
};

const transforms = {
    [priceTagTransforms.loyaltyCustomerAvailability]: {
        toMechanic: (value, { loyaltyKey, defaultCustomerAvailability }) =>
            value ? loyaltyKey : defaultCustomerAvailability,
        fromMechanic: (value, { loyaltyKey }) => !isNil(value) && value === loyaltyKey,
    },
    [priceTagTransforms.limitUnitsToTriggers]: {
        toMechanic: (units, { offerMechanic }) => {
            if (isNil(units) || units === '') return null;
            return Math.max(1, Math.floor(units / getUnitsPerTrigger(offerMechanic)));
        },
        fromMechanic: (triggers, { offerMechanic }) => {
            if (isNil(triggers)) return null;
            return triggers * getUnitsPerTrigger(offerMechanic);
        },
    },
    [priceTagTransforms.tierCount]: {
        toMechanic: (value, { offerMechanic, maxTierCount }) => {
            const existingTierCount = Array.isArray(offerMechanic?.tiers)
                ? offerMechanic.tiers.length
                : 0;
            const fallbackCount = Math.max(existingTierCount || 1, 1);
            const resolvedMax = Math.max(Number(maxTierCount) || fallbackCount, 1);
            const requested =
                isNil(value) || value === '' ? fallbackCount : Math.floor(Number(value));
            const tierCount = Math.min(Math.max(requested || fallbackCount, 1), resolvedMax);

            if (!Array.isArray(offerMechanic.tiers) || !offerMechanic.tiers.length) {
                offerMechanic.tiers = [{}];
            }

            if (offerMechanic.tiers.length > tierCount) {
                offerMechanic.tiers = offerMechanic.tiers.slice(0, tierCount);
            }

            while (offerMechanic.tiers.length < tierCount) {
                offerMechanic.tiers.push(
                    cloneDeep(offerMechanic.tiers[offerMechanic.tiers.length - 1])
                );
            }

            return tierCount;
        },
        fromMechanic: (value, { offerMechanic, maxTierCount }) => {
            const countFromMechanic = Array.isArray(offerMechanic?.tiers)
                ? offerMechanic.tiers.length
                : 1;
            const resolvedMax = Math.max(Number(maxTierCount) || countFromMechanic || 1, 1);
            const candidate =
                isNil(value) || value === '' ? countFromMechanic : Math.floor(Number(value));
            return Math.min(Math.max(candidate || 1, 1), resolvedMax);
        },
    },
};

export const getTransform = name => transforms[name] || identity;

export default { getTransform };
